import { render, staticRenderFns } from "./PhysicalAssessmentCheck.vue?vue&type=template&id=20fb7a3e&scoped=true&"
import script from "./PhysicalAssessmentCheck.vue?vue&type=script&lang=js&"
export * from "./PhysicalAssessmentCheck.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalAssessmentCheck.vue?vue&type=style&index=0&id=20fb7a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fb7a3e",
  null
  
)

export default component.exports